import React, { Component } from 'react'
import '../styles/SiteDetails.css'
import SiteCreation from './SiteCreation'
import SiteWorkingGroup from './SiteWorkingGroup'
import LocalStudyTeam from './LocalStudyTeam'
import ProspectiveBuyerForm from './ProspectiveBuyerForm'
import ProspectiveBuyers from './ProspectiveBuyers'
import SupplyPlans from './SupplyPlans'
import SupplyPlanForm from './SupplyPlanForm'

class SiteDetails extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			disabled: props.disabled,
			isViewDetails: props.isViewDetails,
			siteId: props.siteId
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.setContent = this.setContent.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
	}

	onSubmit() {
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("sites-tabId"))
	}

	eventHandler(e) {
		console.log('eventHandler SiteDetails', e)
		this.props.selectView(sessionStorage.getItem("sites-curr-view"), this.props.siteId, e)
	}

	setContent(id, formId) {
		console.log('this.props.siteId', this.props.siteId)
		let isDisabled = (this.props.view === "update")? false: true
		let content
		switch(id) {
			case "sdh-swg":
				content = <SiteWorkingGroup siteId={this.props.siteId} disabled={isDisabled} key="swg" />
				break
			case "sdh-lst":
				content = <LocalStudyTeam siteId={this.props.siteId} disabled={isDisabled} key="lst" />
				break
			case "sdh-pb":
			case "sdh-btn":
				content = <ProspectiveBuyers siteId={this.props.siteId} onAddClick={this.setContent}
					viewDetails={(id) => {this.setContent("sdh-pbf", id)}} key="pb" />
				break
			case "sdh-pbf":
				content = <ProspectiveBuyerForm pbid={formId} handleFooterEvent={this.eventHandler}
					siteId={this.props.siteId} disabled={(formId == null)? false: true} key="pbf" />
				break
			case "sdh-su":
				content = <SupplyPlans siteId={this.props.siteId} onAddClick={this.setContent}
					viewDetails={(id) => {this.setContent("sdh-suf", id)}} key="su" />
				break
			case "sdh-suf":
				content = <SupplyPlanForm spid={formId} handleFooterEvent={this.eventHandler}
					siteId={this.props.siteId} disabled={(formId == null)? false: true} key="suf" />
				break
			default:
				content = <SiteCreation id={this.props.siteId} view={"view-details"} key="sp" />
		}
		this.setState({
			content: content,
			ispb: (id === "sdh-pbf")? true: false
		})
	}

	render() {
		const view = <div id="site-details">
			<Header onItemClick={(item) => {
				this.props.selectView(sessionStorage.getItem("sites-curr-view"),
					this.props.siteId, item)
				sessionStorage.setItem("sites-tabId", item)
			}} disabled={this.state.disabled} ispb={this.state.ispb} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {disabled: props.disabled, ispb: false}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#site-details-header > div')
		for(const f of items) {
			f.style.color = "#000"
		}
		const imgs = document.querySelectorAll('#site-details-header > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("sites-tabId")
		switch(tabId) {
			case "sdh-lst":
			case "sdh-swg":
			case "sdh-pb":
			case "sdh-su":
				var elem = document.getElementById(tabId)
				break
			default:
				elem = document.getElementById("sdh-sp")
		}
		elem.style.background = "#e2e2e2"
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				return
			}
			const items = document.querySelectorAll('#site-details-header > div')
			for(const f of items) {
				f.style.color = "#000"
			}
			const imgs = document.querySelectorAll('#site-details-header > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#site-details-header > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="site-details-header">
			<div id="sdh-sp" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>SITE PROFILE</div>
			<div id="sdh-swg" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>SITE WORKING GROUP</div>
			<div id="sdh-lst" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>LOCAL STUDY TEAM</div>
			<div id="sdh-pb" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>PROSPECTIVE BUYERS</div>
			{/* <div id="sdh-su" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>SUPPLY PLAN</div> */}
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="site-details-body">
			<div id="sdb-content">
				{this.props.content}
			</div>
		</div>
		return(view)
	}
}

export default SiteDetails
